export default __webpack_public_path__ + "static/media/link-icon.9ad263be.svg";